import filePreviewTemplate from './file-preview.html';

// eslint-disable-next-line no-undef
@Inject('$sce')
class FilePreviewController {
  constructor() {
    this.content = this.$sce.trustAsResourceUrl(this.url);
  }
}

export default class FilePreviewComponent {
  constructor() {
    this.template = filePreviewTemplate;
    this.controller = FilePreviewController;
    this.bindings = {
      url: '<',
      type: '<',
    };
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/utils/file-preview/components/file-preview/file-preview-component.js